// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import SocialStatus from "enums/SocialStatus";
import User, { processUser } from "./User";
import Util from "PreciateUtil";

export default interface SocialAttendee {
    socialAttendeeId?: string;
    socialId?: string;
    attendeeUserId?: string;
    attendeeUser?: User;
    dateTimeArrived?: Date;
    isHost?: boolean;
    isPresent?: boolean;
    location?: string;
    ringColor?: string;
    tokenId?: string;
    streamConnectionId?: string;
    status?: SocialStatus;
    queuePosition?: number;
    queueLength?: number;
    presenterVideoQuality?: string;
    socialChanged?: boolean;
    updatedWebsocketURL?: string;
    favoriteUserIds?: string[];
}

export function processSocialAttendee(value?: SocialAttendee): void {
  if (value) {
    value.dateTimeArrived = Util.toDate((value as any).dateTimeArrived);
    processUser(value.attendeeUser);
  }
}

export function processSocialAttendeeArray(array?: SocialAttendee[]): void {
  if (array) {
    for (const v of array) {
      processSocialAttendee(v);
    }
  }
}
